import createAction, { createClearAction } from "../../app/createAction";
import {
    AUTO_LOGIN_FAILURE,
    AUTO_LOGIN_START,
    AUTO_LOGIN_SUCCESS,
    CHECK_CODE_FAILURE,
    CHECK_CODE_START,
    CHECK_CODE_SUCCESS,
    COMPLETE_MOBILE_LOGIN_STATE_START,
    CREATE_PASSWORD_FAILURE,
    CREATE_PASSWORD_START,
    CREATE_PASSWORD_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGIN_WITH_GOOGLE_START,
    LOGIN_WITH_TELEGRAM_START,
    LOGIN_WITH_TELEGRAM_STOP,
    LOGOUT_FAILURE,
    LOGOUT_START,
    LOGOUT_SUCCESS,
    PASSWORD_RESET_FAILURE,
    PASSWORD_RESET_RESET,
    PASSWORD_RESET_START,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_UPDATE_FAILURE,
    PASSWORD_UPDATE_START,
    PASSWORD_UPDATE_SUCCESS,
    REGISTRATION_FAILURE,
    REGISTRATION_PREPARE,
    REGISTRATION_START,
    REGISTRATION_SUCCESS,
    RESEND_CODE_FAILURE,
    RESEND_CODE_START,
    RESEND_CODE_SUCCESS,
    SET_CHANGE_EMAIL_FAILURE,
    SET_CHANGE_EMAIL_START,
    SET_CHANGE_EMAIL_SUCCESS,
    SET_REGISTRATION_DATA,
} from "./loginConstants";
import { ICompleteMobileLoginStateActionPayload, IFormError, IRegistation } from "./types/loginActions";

export const loginAction = (payload?: unknown) => createClearAction<typeof LOGIN_START>(LOGIN_START, payload);
export const loginSuccess = () => createClearAction<typeof LOGIN_SUCCESS>(LOGIN_SUCCESS);
export const loginFailure = (payload: string | null) => createAction<typeof LOGIN_FAILURE, string | null>(LOGIN_FAILURE, payload);

export const loginWithGoogleAction = (payload: any) => createAction<typeof LOGIN_WITH_GOOGLE_START, any>(LOGIN_WITH_GOOGLE_START, payload);
export const loginWithTelegramAction = () => createClearAction<typeof LOGIN_WITH_TELEGRAM_START>(LOGIN_WITH_TELEGRAM_START);
export const loginWithTelegramStop = () => createClearAction<typeof LOGIN_WITH_TELEGRAM_STOP>(LOGIN_WITH_TELEGRAM_STOP);

export type IlogoutAction = { source: 'LogoutButton' }
export const logoutAction = (payload?: IlogoutAction) => createAction<typeof LOGOUT_START, IlogoutAction | undefined>(LOGOUT_START, payload);
export const logoutSuccess = (payload?: unknown) => createClearAction<typeof LOGOUT_SUCCESS>(LOGOUT_SUCCESS, payload);
export const logoutFailure = (payload?: unknown) => createClearAction<typeof LOGOUT_FAILURE>(LOGOUT_FAILURE, payload);

export const registrationAction = (payload: IRegistation) => createAction<typeof REGISTRATION_START, IRegistation>(REGISTRATION_START, payload);
export const registrationSuccess = (payload: IRegistation) => createAction<typeof REGISTRATION_SUCCESS, IRegistation>(REGISTRATION_SUCCESS, payload);
export const registrationFailure = (payload: IFormError) => createAction<typeof REGISTRATION_FAILURE, IFormError>(REGISTRATION_FAILURE, payload);

export const setRegistrationDataAction = (payload: IRegistation) => createAction<typeof SET_REGISTRATION_DATA, IRegistation>(SET_REGISTRATION_DATA, payload);
export const registrationPrepareAction = (payload?: unknown) => createClearAction<typeof REGISTRATION_PREPARE>(REGISTRATION_PREPARE, payload);

export const passwordResetAction = (payload?: unknown) => createClearAction<typeof PASSWORD_RESET_START>(PASSWORD_RESET_START, payload);
export const passwordResetSuccess = (payload?: unknown) => createClearAction<typeof PASSWORD_RESET_SUCCESS>(PASSWORD_RESET_SUCCESS, payload);
export const passwordResetFailure = (payload: IFormError) => createAction<typeof PASSWORD_RESET_FAILURE, IFormError>(PASSWORD_RESET_FAILURE, payload);
export const passwordResetReset = (payload?: unknown) => createClearAction<typeof PASSWORD_RESET_RESET>(PASSWORD_RESET_RESET, payload);

export const passwordUpdateAction = (payload?: unknown) => createClearAction<typeof PASSWORD_UPDATE_START>(PASSWORD_UPDATE_START, payload);
export const passwordUpdateSuccess = (payload?: unknown) => createClearAction<typeof PASSWORD_UPDATE_SUCCESS>(PASSWORD_UPDATE_SUCCESS, payload);
export const passwordUpdateFailure = (payload: IFormError) => createAction<typeof PASSWORD_UPDATE_FAILURE, IFormError>(PASSWORD_UPDATE_FAILURE, payload);

export const setChangeEmailAction = (payload?: unknown) => createClearAction<typeof SET_CHANGE_EMAIL_START>(SET_CHANGE_EMAIL_START, payload);
export const setChangeEmailSuccess = (payload: boolean) => createAction<typeof SET_CHANGE_EMAIL_SUCCESS, boolean>(SET_CHANGE_EMAIL_SUCCESS, payload);
export const setChangeEmailFailure = (payload?: unknown) => createClearAction<typeof SET_CHANGE_EMAIL_FAILURE>(SET_CHANGE_EMAIL_FAILURE, payload);

export const checkCodeAction = (payload?: unknown) => createClearAction<typeof CHECK_CODE_START>(CHECK_CODE_START, payload);
export const checkCodeSuccess = (payload?: unknown) => createClearAction<typeof CHECK_CODE_SUCCESS>(CHECK_CODE_SUCCESS, payload);
export const checkCodeFailure = (payload: IFormError) => createAction<typeof CHECK_CODE_FAILURE, IFormError>(CHECK_CODE_FAILURE, payload);

export const createPasswordAction = (payload?: unknown) => createClearAction<typeof CREATE_PASSWORD_START>(CREATE_PASSWORD_START, payload);
export const createPasswordSuccess = (payload?: unknown) => createClearAction<typeof CREATE_PASSWORD_SUCCESS>(CREATE_PASSWORD_SUCCESS, payload);
export const createPasswordFailure = (payload: IFormError) => createAction<typeof CREATE_PASSWORD_FAILURE, IFormError>(CREATE_PASSWORD_FAILURE, payload);

export const resendCodeAction = (payload?: unknown) => createClearAction<typeof RESEND_CODE_START>(RESEND_CODE_START, payload);
export const resendCodeSuccess = (payload?: unknown) => createClearAction<typeof RESEND_CODE_SUCCESS>(RESEND_CODE_SUCCESS, payload);
export const resendCodeFailure = (payload?: unknown) => createClearAction<typeof RESEND_CODE_FAILURE>(RESEND_CODE_FAILURE, payload);

export const autoLoginAction = (payload?: unknown) => createClearAction<typeof AUTO_LOGIN_START>(AUTO_LOGIN_START, payload);
export const autoLoginSuccess = (payload?: unknown) => createClearAction<typeof AUTO_LOGIN_SUCCESS>(AUTO_LOGIN_SUCCESS, payload);
export const autoLoginFailure = (payload?: unknown) => createClearAction<typeof AUTO_LOGIN_FAILURE>(AUTO_LOGIN_FAILURE, payload);

export const completeMobileLoginStateAction = (payload: ICompleteMobileLoginStateActionPayload) =>
    createAction(COMPLETE_MOBILE_LOGIN_STATE_START, payload);
